import { render } from "./SkillComponent.vue?vue&type=template&id=2e6b2055&scoped=true"
import script from "./SkillComponent.vue?vue&type=script&lang=js"
export * from "./SkillComponent.vue?vue&type=script&lang=js"

import "./SkillComponent.vue?vue&type=style&index=0&id=2e6b2055&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6b2055"]])

export default __exports__